import {
  SCHWAB_ONE_PERSONAL,
  SCHWAB_IRA,
  SCHWAB_ONE_TRUST,
  SCHWAB_CHARITABLE,
} from 'utils/financialAccountTypes.js'
import {
  mapAccountDetailsValues,
  mapEmployerInformationFields,
  mapAdditionalDetailsFields,
  mapTrustDetailsValues
} from './formDataMapping'

export const schwabPersonalDetails = {
  fields: {
    accountHolderFormHeader:'Primary Account Holder',
    accountHolderFormName: 'primaryAccountHolderName',
    accountHolderFormLastName: 'primaryAccountHolderLastName',
    jointAccountFormName: 'jointAccountHolderName',
    jointAccountFormLastName: 'jointAccountHolderLastName',
    jointAccountFormHeader: 'Joint Account Holder',
    paperlessFormName: 'paperlessDelivery',
    firstName: 'firstName',
    middleName: 'middleName',
    lastName: 'lastName',
    personBirthdate: 'personBirthdate',
    ssn: 'ssn',
    dateOfDeath: 'dateOfDeath',
    accountTypeHeader: 'Type Of Account',
    accountTypeValue:'Schwab One Brokerage',
    minorFirstName: 'minorFirstName',
    minorMiddleName: 'minorMiddleName',
    minorLastName: 'minorLastName',
    minorDateOfBirth: 'minorDateOfBirth',
    minorSsn: 'minorSsn',
    minorSsnLastFour: 'minorSsnLastFour',
    minorAgeOfTermination: 'minorAgeOfTermination',
  },
  description: `Let’s look at your ${SCHWAB_ONE_PERSONAL.DISPLAY} account.`,
  upperTitle: SCHWAB_ONE_PERSONAL.DISPLAY,
  section: 'personalAccountDetails',
  fieldsToSubmit: mapAccountDetailsValues,
  accountType: SCHWAB_ONE_PERSONAL.ACCOUNT_TYPE_ROUTE
}

const IRADetailsDescription = ' Let’s look at your IRA.'

export const schwabIRADetails = {
  fields: {
    accountHolderFormHeader:'Account Holder Name',
    accountHolderFormName: 'primaryAccountHolderName',
    accountHolderFormLastName: 'primaryAccountHolderLastName',
    paperlessFormName: 'paperlessDelivery',
    accountTypeHeader: 'IRA type',
    deceasedFirstName: 'deceasedFirstName',
    deceasedMiddleName: 'deceasedMiddleName',
    deceasedLastName: 'deceasedLastName',
    deceasedSsn: 'deceasedSsn',
    deceasedSsnLastFour: 'deceasedSsnLastFour',
    deceasedDob: 'deceasedDob',
    deceasedDod: 'deceasedDod',
    minorFirstName: 'minorFirstName',
    minorMiddleName: 'minorMiddleName',
    minorLastName: 'minorLastName',
    minorDateOfBirth: 'minorDateOfBirth',
    minorSsn: 'minorSsn',
    minorSsnLastFour: 'minorSsnLastFour',
    minorAgeOfTermination: 'minorAgeOfTermination',
    accountTypeValue: SCHWAB_IRA.ACCOUNT_TYPES.TRADITIONAL_IRA,
  },
  section: 'IRAAccountDetails',
  accountNameProperty: 'accountHolder',
  description: IRADetailsDescription,
  upperTitle: SCHWAB_IRA.DISPLAY,
  fieldsToSubmit: mapAccountDetailsValues,
  accountType: SCHWAB_IRA.ACCOUNT_TYPE_ROUTE
}

export const schwabCharitableDetails = {
  fields: {
    accountHolderFormHeader:'Account Holder Name',
    accountHolderFormName: 'primaryAccountHolderName',
    accountHolderFormLastName: 'primaryAccountHolderLastName',
    paperlessFormName: 'paperlessDelivery',
    anotherDonor: 'anotherDonor',
    donorFirstName: 'donorFirstName',
    donorMiddleName: 'donorMiddleName',
    donorLastName: 'donorLastName',
    donorSocialSecurityNumber: 'donorSocialSecurityNumber',
    donorSsnLastFour: 'donorSsnLastFour',
    donorDateOfBirth: 'donorDateOfBirth',
    donorPhone: 'donorPhone',
    donorAddress: 'donorAddress',
    donorCity: 'donorCity',
    donorState: 'donorState',
    donorZipCode: 'donorZipCode',
    donorCountry: 'donorCountry',
    donorEmail: 'donorEmail',
    donorOccupation: 'donorOccupation',
    donorAdvisedFundName: 'donorAdvisedFundName',
    accountTypeHeader: 'SCHWAB Charitable',
    accountTypeValue: SCHWAB_CHARITABLE.ACCOUNT_TYPES.DONOR_ADVISED_FUND,
  },
  section: 'IRAAccountDetails',
  accountNameProperty: 'accountHolder',
  description: IRADetailsDescription,
  upperTitle: SCHWAB_CHARITABLE.DISPLAY,
  fieldsToSubmit: mapAccountDetailsValues,
  accountType: SCHWAB_CHARITABLE.ACCOUNT_TYPE_ROUTE
}

export const employerInformation = {
  upperTitle: 'Employer Information',
  description: ['Since you’re opening a {subType}, we need to get some information about the employer tied to the account.'],
  fieldsToSubmit: mapEmployerInformationFields,
  fields: {
    employerCity: 'employerCity',
    employerCountry: 'employerCountry',
    employerEffectiveDateConfiguration: 'employerEffectiveDateConfiguration',
    employerFiscalYearEndDay: 'employerFiscalYearEndDay',
    employerFiscalYearEndMonth: 'employerFiscalYearEndMonth',
    employerIdentificationNumber: 'employerIdentificationNumber',
    employerName: 'employerName',
    employerPhone: 'employerPhone',
    employerPlanEffectiveDate: 'employerPlanEffectiveDate',
    employerIncomeTaxDate: 'employerIncomeTaxDate',
    employerPostalCode: 'employerPostalCode',
    employerPriorPlanEffectiveDate: 'employerPriorPlanEffectiveDate',
    employerState: 'employerState',
    employerStreetAddress: 'employerStreetAddress',
    employerPlanName: 'employerPlanName',
    employerTypeOfBusiness: 'employerTypeOfBusiness',
    subType: 'subType'
  }
}

export const additionalDetails = {
  upperTitle: 'Additional Questions',
  fieldsToSubmit: mapAdditionalDetailsFields,
  fields: {
    sepApproveDefaultAdditionalDetails: 'sepApproveDefaultAdditionalDetails',
    sepPlanServiceRequirement: 'sepPlanServiceRequirement',
    sepPlanServiceRequirementDetails: 'sepPlanServiceRequirementDetails',
    sepPlanAgeRequirement: 'sepPlanAgeRequirement',
    sepEmployedAsOfEffectiveDate: 'sepEmployedAsOfEffectiveDate',
    sepEligibleClassParticipantsA: 'sepEligibleClassParticipantsA',
    sepEligibleClassParticipantsB: 'sepEligibleClassParticipantsB',
    sepEligibleClassParticipantsC: 'sepEligibleClassParticipantsC',
    sepEligibleClassParticipantsD: 'sepEligibleClassParticipantsD',
    sepContributionFormula: 'sepContributionFormula',
    sepContributionFormulaPercentage: 'sepContributionFormulaPercentage',
    sepContributionFormulaDollar: 'sepContributionFormulaDollar',
    sepAllocationFormula: 'sepAllocationFormula',
    sepIntegratedFormulaLevelPercentage: 'sepIntegratedFormulaLevelPercentage',
    sepTopHeavyMinimumAllocation: 'sepTopHeavyMinimumAllocation',
    sepTopHeavyMinimumAllocationName: 'sepTopHeavyMinimumAllocationName',
    sepCompensationElections: 'sepCompensationElections',
    sepPlanYearElections: 'sepPlanYearElections',
    sepPlanYearElectionsCustomPeriod: 'sepPlanYearElectionsCustomPeriod',
    sepElectiveDeferralDollar: 'sepElectiveDeferralDollar',
    sepElectiveDeferralPercentage: 'sepElectiveDeferralPercentage',
    sepAllowSeparateDeferral: 'sepAllowSeparateDeferral',
    sepCatchUpContributionsPermitted: 'sepCatchUpContributionsPermitted',
    simpleApproveDefaultAddtlDetails: 'simpleApproveDefaultAddtlDetails',
    simpleCatchUpContributionsPermitted: 'simpleCatchUpContributionsPermitted',
    simpleCurrentYearCompAmount: 'simpleCurrentYearCompAmount',
    simpleEligibilityServiceRequirement: 'simpleEligibilityServiceRequirement',
    eligibilityServiceRequirement: 'eligibilityServiceRequirement',
    eligibilityServiceRequirementMonths: 'eligibilityServiceRequirementMonths',
    eligibilityServiceRequirementYears: 'eligibilityServiceRequirementYears',
    simpleEligibleClassParticipantsA: 'simpleEligibleClassParticipantsA',
    simpleEligibleClassParticipantsB: 'simpleEligibleClassParticipantsB',
    simpleEligibleClassParticipantsC: 'simpleEligibleClassParticipantsC',
    simpleMinCompForEmployerContrib: 'simpleMinCompForEmployerContrib',
    simpleModificationElectionPeriods: 'simpleModificationElectionPeriods',
    simplePriorYearCompAmount: 'simplePriorYearCompAmount',
    simplePriorYearCompYears: 'simplePriorYearCompYears',
    subType: 'subType'
  }
}

const trustDetailsDescription = `Let's look at your ${SCHWAB_ONE_TRUST.DISPLAY} Account.
 Review and update the information below.`

export const schwabTrustDetails = {
  fields: {
    accountHolderFormName: 'trustName',
    accountHolderFormLastName: '',
    trustName: 'trustName',
    dateOfTrust: 'dateOfTrust',
    paperlessFormName: 'paperlessDelivery',
    taxIdentificationNumber: 'taxIdentificationNumber',
    trustGovernedInStateOf: 'trustGovernedInStateOf',
    publicCompanyAffiliated: 'publicCompanyAffiliated',
    lastFourDigitTaxId: 'lastFourDigitTaxId',
    irrevocableTrustType: 'irrevocableTrustType',
    decedentFirstName: 'decedentFirstName',
    decedentLastName: 'decedentLastName'
  },
  section: 'TrustAccountDetails',
  accountNameProperty: 'accountHolder',
  description: trustDetailsDescription,
  upperTitle: SCHWAB_ONE_TRUST.DISPLAY,
  fieldsToSubmit: mapTrustDetailsValues,
  accountType: SCHWAB_ONE_TRUST.ACCOUNT_TYPE_ROUTE
}

export const allAccountDetails = {
  schwab_one_trust: schwabTrustDetails,
  schwab_ira: schwabIRADetails,
  schwab_one_personal: schwabPersonalDetails,
  schwab_charitable: schwabCharitableDetails,
}



// WEBPACK FOOTER //
// ./src/utils/financialAccountDetailsConfig.js